import { stdObject } from "../../../data/types/stdObject";
import { getIssueKey } from "../../../utils/getIssueKey";
import DictionaryTable from "./DictionaryTable";
import NOPIC from "../../../assets/nopic.svg";
import { colors } from "../../../data/colors";
import convertDate from "../../../utils/convertDate";
import { useTranslation } from "react-i18next";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

export default function RecordIssues({ data, mainWidth }: stdObject) {
  const { t } = useTranslation();

  const writeCheckValue = () =>
    data[getIssueKey(data.TIPSDD)] !== "" ? (
      <div style={{ padding: 5 }}>
        <b>{data.NOMSDD}: </b>
        {data[getIssueKey(data.TIPSDD)] ? (
          <CheckBoxOutlineBlankIcon
            style={{ fontSize: 16, color: colors.darkGrey }}
          />
        ) : (
          <CheckBoxIcon style={{ fontSize: 16, color: colors.darkGrey }} />
        )}
      </div>
    ) : (
      <></>
    );

  const writeFinalValues = () =>
    data[getIssueKey(data.TIPSDD)] !== "" ? (
      <div style={{ padding: 5 }}>
        <b>{data.NOMSDD}: </b>
        {data.TIPSDD === 3
          ? data[getIssueKey(data.TIPSDD)].replaceAll("<br>", "\n")
          : data.TIPSDD === 7
            ? convertDate({
                info: data[getIssueKey(data.TIPSDD)],
                time: false,
                t,
              })
            : data[getIssueKey(data.TIPSDD)]}
        {" " + data.SUFSDD}
      </div>
    ) : (
      <></>
    );

  const writeLongTextValues = () =>
    data[getIssueKey(data.TIPSDD)] !== "" ? (
      <div style={{ padding: 5 }}>
        <div style={{ fontWeight: "bolder" }}>{data.NOMSDD}</div>
        <div style={{ paddingLeft: 10 }}>
          {data[getIssueKey(data.TIPSDD)]
            .split("<br>")
            .map((e: string, index: number) => (
              <div key={index}>{e}</div>
            ))}
        </div>
      </div>
    ) : (
      <></>
    );

  return data.TIPSDD === 0 ? (
    writeCheckValue()
  ) : data.TIPSDD === 8 ? (
    <DictionaryTable
      label={data.NOMSDD}
      data={data[getIssueKey(data.TIPSDD)]}
    />
  ) : data.TIPSDD === 3 ? (
    writeLongTextValues()
  ) : [1, 2, 3, 4, 6, 7].includes(data.TIPSDD) ? (
    writeFinalValues()
  ) : data.TIPSDD === 5 ? (
    !!data.DRAWING ? (
      <div
        className="listImage"
        style={{ width: 250, height: 175, margin: 3 }}
        onClick={data.onClick}
      >
        <img
          src={data.DRAWING}
          onError={(v: any) => (v.target.src = NOPIC)}
          loading="lazy"
          alt={data.CODSDD}
        />
      </div>
    ) : (
      <></>
    )
  ) : (
    <div
      style={{
        backgroundColor: colors.lightGrey,
        fontSize: 12,
        fontWeight: "bolder",
        padding: 5,
      }}
    >
      {data.NOMSDD}
    </div>
  );
}
